import {
  CandidateOpportunitiesConst,
  MLRecommendationStatuses,
} from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';
import { z } from 'zod';

const candidateStatusValues = Object.values(
  CandidateOpportunitiesConst.CandidateStatuses
);

const mlCandidateStatuses = Object.values(MLRecommendationStatuses);

export const CandidateOpportunityCandidateStatuses = [
  ...candidateStatusValues,
  ...mlCandidateStatuses,
];

export const ZodCandidateOpportunityCandidateStatuses = z.enum(
  ZodArrayToEnum(CandidateOpportunityCandidateStatuses)
);

export type CandidateOpportunityCandidateStatuses = z.infer<
  typeof ZodCandidateOpportunityCandidateStatuses
>;
